/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */


const theme = {
  appearances: {
    compact: {
      description: 'When true it will reduce the line height of the list item.',
      type: 'variant',
      values: [ true ]
    },
    size: {
      description: 'Indicates list item text size.',
      type: 'variant',
      values: [ 'large', 'medium', 'small' ]
    }
  },
  rules: [
    {
      if: { size: 'large' },
      tokens: { itemFontSize: 20, itemLineHeight: 1.4 }
    },
    {
      if: { size: 'small' },
      tokens: { itemFontSize: 16, itemLineHeight: 1.55555555 }
    },
    { if: { compact: true }, tokens: { itemLineHeight: 1.55555555 } },
    {
      if: { compact: true, size: 'small' },
      tokens: { itemLineHeight: 1.5 }
    },
    {
      if: { compact: true, size: 'large' },
      tokens: { itemLineHeight: 1.4 }
    }
  ],
  tokens: {
    headerFontName: 'SofiaPro',
    headerFontWeight: '700',
    interItemMargin: 8,
    itemBulletContainerWidth: 20,
    itemBulletHeight: 4,
    itemBulletTextAlign: 'right',
    itemBulletWidth: 4,
    itemColor: null,
    itemFontName: 'SofiaPro',
    itemFontSize: 18,
    itemFontWeight: '400',
    itemLineHeight: 1.55555555,
    itemMarginTop: 0,
    itemPaddingTop: 0,
    itemTextColor: '#394056',
    listGutter: 8
  }
}
export default theme
